<template>
  <section id="contact" class="contact-section">
    <div class="contact-section__inner content-width">
      <p class="eyebrow">{{ $store.getters.t('contact') }}</p>
      <h2>{{ $store.getters.t('contact') }}</h2>
      <p class="contact-copy contact-copy--desktop">{{ contactCopy }}</p>
      <p class="contact-copy contact-copy--mobile">{{ contactCopy }}</p>
      <form class="contact-form" @submit.prevent="submit">
        <textarea
          v-model.trim="message"
          class="contact-message"
          maxlength="500"
          :placeholder="$store.getters.t('messagePlaceholder')"
          :aria-label="$store.getters.t('messagePlaceholder')"
        ></textarea>
        <div class="contact-form__row">
          <input v-model.trim="email" type="text" maxlength="128" :placeholder="$store.getters.t('contactPlaceholder')" :aria-label="$store.getters.t('contactPlaceholder')">
          <button type="submit" class="button button-dark" :disabled="submitting">
            <span class="form-submit-desktop">{{ submitting ? '...' : $store.getters.t('subscribe') }}</span>
            <span class="form-submit-mobile">{{ submitting ? '...' : $store.getters.t('subscribe') }}</span>
          </button>
        </div>
        <div v-if="captchaImage" class="contact-captcha">
          <input
            v-model.trim="captchaCode"
            type="text"
            maxlength="4"
            class="contact-captcha__input"
            autocomplete="off"
            :placeholder="$store.getters.t('captchaPlaceholder')"
            :aria-label="$store.getters.t('captchaPlaceholder')"
          >
          <img
            class="contact-captcha__image"
            :src="captchaImage"
            :alt="$store.getters.t('captchaPlaceholder')"
            :title="$store.getters.t('captchaRefresh')"
            @click="loadCaptcha"
          >
        </div>
      </form>
      <p v-if="success" class="form-message form-message--success">{{ $store.getters.t('sendSuccess') }}</p>
      <p v-if="error" class="form-message form-message--error">{{ error }}</p>
    </div>
  </section>
</template>

<script>
import { submitContact, getCaptcha } from '../api/portal'
import { formatCopyText } from '../utils/copyText'

export default {
  name: 'ContactSection',
  data () {
    return {
      email: '',
      message: '',
      captchaId: '',
      captchaCode: '',
      captchaImage: '',
      submitting: false,
      success: false,
      error: ''
    }
  },
  created () {
    this.loadCaptcha()
  },
  computed: {
    // CONTACT US 文案：句首大写、其余小写，品牌名 BECANE 保持大写
    contactCopy () {
      return formatCopyText(this.$store.getters.t('contactCopy'))
    }
  },
  methods: {
    // 拉取（或点击图片刷新）图形验证码
    async loadCaptcha () {
      try {
        const result = await getCaptcha()
        const data = (result && (result.data || result)) || {}
        this.captchaId = data.captchaId || ''
        this.captchaImage = data.image || ''
        this.captchaCode = ''
      } catch (error) {
        // 验证码拉取失败时不阻塞页面；后端校验不通过会给出提示
        this.captchaId = ''
        this.captchaImage = ''
      }
    },
    async submit () {
      this.success = false
      this.error = ''
      if (this.captchaImage && !this.captchaCode) {
        this.error = this.$store.getters.t('captchaRequired')
        return
      }
      this.submitting = true
      try {
        // 联系方式为选填项：可以是邮箱、电话、微信等任意文本，也可以留空。
        await submitContact({
          name: '',
          email: this.email,
          phone: '',
          message: this.message || '官网咨询',
          captchaId: this.captchaId,
          captchaCode: this.captchaCode
        })
        this.success = true
        this.email = ''
        this.message = ''
        this.loadCaptcha()
      } catch (error) {
        this.error = (error.response && error.response.data && error.response.data.message) || error.message || this.$store.getters.t('submissionFailed')
        // 验证码一次性使用，失败后必须换一张
        this.loadCaptcha()
      } finally {
        this.submitting = false
      }
    }
  }
}
</script>
